<div [class.item-selected]="selected">
  @if (iconType && iconType !== 'bg-icon' && iconType !== 'big-image-bottom') {
    <div
      class="icon-wrapper"
      [style.background-color]="color ? color : '#ffffff'"
      [style.line-height]="color ? 'inherit' : 'initial'"
      [ngClass]="{ imgblock: (iconType === 'big-image' || iconType === 'graph'),}"
      >
      @if (iconType === 'image' || iconType === 'big-image') {
        <img
          src="{{ icon }}"
          />
      }
      @if (iconType === 'material') {
        <mat-icon [inline]="true" mat-header>
          {{ icon }}</mat-icon
          >
        }
        @if (iconType === 'graph') {
          <div class="contentG">
            <div class="box gauge--1">
              <div class="mask">
                <div class="semi-circle"></div>
                <div class="semi-circle--mask" [ngStyle]="graphStyles(value)"></div>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div class="details d{{ iconType }}">
      <div
        class="title t{{ iconType }}"
      [ngStyle]="{
        background:
          iconType === 'big-image-bottom' ? 'url(' + icon + ') no-repeat bottom right' : 'none'
      }"
        >
        @if (iconType !== 'bg-icon') {
          <span
            class="no-wrap"
            [matTooltip]="tooltip"
            matTooltipPosition="above"
            >{{ title }}</span
            >
          }
          @if (iconType === 'bg-icon') {
            <span
              class="bg-icon"
              [ngStyle]="{ background: 'url(' + icon + ')' }"
              [matTooltip]="tooltip"
              matTooltipPosition="above"
              >{{ title }}</span
              >
            }
          </div>
          @if ((value !== undefined && value !== null) || na) {
            <div class="value t{{ iconType }}">
              @if (iconType === 'big-image-bottom') {
                <img src="{{ icon }}" />
              }
              {{ na ? 'N/A' : formattedValue }}
              @if (linkUrl && linkText) {
                <a
                  class="support-link"
                  href="{{ linkUrl }}"
                  target="_blank"
                  >{{ linkText }}</a
                  >
                }
              </div>
              @if (prvValue !== null && prvValue !== undefined && period) {
                <div
                  class="change"
                  class="{{ percentClass(value, prvValue) }}"
                  >
                  <span class="change-arrow">
                    @if (value > prvValue) {
                      <mat-icon class="">call_made</mat-icon>
                    }
                    @if (value < prvValue) {
                      <mat-icon>call_received</mat-icon>
                    }
                    @if (value === prvValue || value === null) {
                      <mat-icon
                        >remove</mat-icon
                        >
                      }
                    </span>
                    <span class="change-value">{{ changePercent }}%</span>
                    <span>{{ 'inLastDays' | translate : { val: period } }} </span>
                  </div>
                }
                <div class="info-msg">{{ info }}</div>
              }
              @if ((value === undefined || value === null) && !na) {
                <div class="loader-container">
                  <app-tiny-loader></app-tiny-loader>
                </div>
              }
            </div>
          </div>
